module.exports = {
    "over_size_message": "الصورة التي قمت بتحميلها تتجاوز 10 أمتار. ",
    "file_type_error": "الملف الذي قمت بتحميله ليس صورة! ",
    "upload_error": "خطأ في تحميل! ",
    "watermark_remove_over_size": "الصورة التي تم تحميلها أكثر من 5 أمتار. ",
    "watermark_remove_file_type_error": "الملف الذي قمت بتحميله ليس صورة ، يرجى التحميل مرة أخرى.",
    "watermark_remove_image_type_error": "تنسيق الصورة غير مدعوم. ",
    "watermark_remove_upload_error": "خطأ التعرف (رمز الخطأ: 2001) ، يرجى المحاولة مرة أخرى ...",
    "watermark_remove_processing": "معالجة الصورة ...",
    "watermark_remove_not_save": "لن يتم الاحتفاظ بالمنطقة التي اخترتها. ",
    "watermark_remove_back_home": "لن يتم حفظ الوضع الحالي. ",
    "watermark_remove_new_image": "لن يتم حفظ الوضع الحالي. ",
    "watermark_select": "يختار",
    "watermark_select_area": "يرجى تحديد منطقة العلامة المائية التي تريد محوها قبل النقر فوق الإزالة.",
    "watermark_beyond_4k": "تتجاوز الصورة المحددة دقة 4K. ",
    "watermark_beyond_pixel_1": "يتجاوز دقة الصورة المحددة <span> ٪ SPX </span> <span> × ٪ SPX </span>. ",
    "watermark_beyond_pixel_2": "يمكن للزوار معالجة الصور <span> ٪ S </span> مع الدقة على <span> ٪ SPX </spx> x <span> ٪ spx </spx> ، يرجى تسجيل الدخول والمتابعة.",
    "watermark_beyond_size_1": "يتجاوز حجم الصورة المحدد <span> ٪ Smb </span>. ",
    "watermark_beyond_size_2": "يتجاوز حجم الصورة المحدد <span> ٪ smb </span> ، ولكن يمكن للزوار معالجة الصور أقل من <span> ٪ Smb </span>. ",
    "no_user_down": "يمكن للزوار فقط تنزيل الصور <span> ٪ S </span> مع الجودة الأصلية. ",
    "no_down_rights": "لا يمكن تنزيل صور HD بجودة أصلية ، يرجى ترقية خطتك! ",
    "error_40001": "خطأ: 40001. يرجى الاتصال بنا",
    "error_40099": "خطأ: 40099. يرجى الاتصال بنا",
    "down_btn": "التنزيل قيد الإعداد ، يرجى الانتظار لثانية ...",
    "noRemove_down_btn": "لم تفعل أي شيء لإزالة العلامات المائية. ",
    "history_open": "فتح الصورة المعدلة ، يرجى الانتظار لحظة ...",
    "maskRightsMonitor_info": "تم فتح صفحة ترقية الصفحة في علامة تبويب جديدة ، وسيتم تزامن خطتك تلقائيًا بعد الترقية.",
    "maskLoginMonitor_info": "تم فتح الصفحة المقصودة ، يرجى إكمال تسجيل الدخول إليها. ",
    "photo_rights_info": "<span> <i class = \"num\"> 2 </i> HD Image (s) </span> مع الجودة الأصلية يمكن تنزيلها في الوقت الحاضر. ",
    "rights_original": "لتشغيل \"استخدام وظيفة محسن الصور لتقليل فقدان الجودة\" ، تحتاج إلى ترقية حسابك!",
    "Brush": "فرشاة",
    "Lasso": "لاسو",
    "Polygonal": "متعدد الأضلاع",
    "Eraser": "ممحاة",
    "Free": "حر",
    "More": "أكثر:",
    "Select": "يختار",
    "Remove": "يزيل",
    "BrushSize": "حجم الفرشاة:",
    "AspectRatio": "نسبة العرض إلى الارتفاع:",
    "Upload": "صورة جديدة",
    "History": "تاريخ",
    "Login": "تسجيل الدخول",
    "MyAccount": "حسابي",
    "Logout": "تسجيل الخروج",
    "Usinghelp": "باستخدام المساعدة >>",
    "Enhancer": "استخدم وظيفة محسن الصور لتقليل فقدان الجودة",
    "Download": "تحميل",
    "Guide": "مرشد",
    "Polygonal1": "متعدد الأضلاع:",
    "Polygonal_info": "انقر فوق زر الماوس الأيسر لتحديد نقطة في وقت واحد.",
    "Lasso1": "لاسو:",
    "Lasso_info": "اضغط لفترة طويلة على زر الماوس الأيسر إلى Lasso منطقة العلامة المائية.",
    "Brush1": "فرشاة:",
    "Brush_info": "اضغط لفترة طويلة على زر الماوس الأيسر لتحديد بدقة.",
    "Eraser1": "ممحاة:",
    "Eraser_info": "محو الأجزاء غير الضرورية من المنطقة المحددة.",
    "Click": "انقر",
    "the": "ال",
    "click_info": "زر لبدء التأثير على العلامة المائية غير المرغوب فيها.",
    "PleaseUploadImages": "يرجى تحميل الصور.",
    "CropInfo": "بمجرد الانتهاء من عملية إزالة العلامة المائية ، يمكنك النقر فوق زر المحصول لاقتصاص صورتك قبل حفظه ، أو انقر فوق زر التنزيل لحفظ الصورة الحالية مباشرة.",
    "Crop": "اقتصاص",
    "Back": "خلف",
    "DownloadCropped": "تنزيل اقتصاص",
    "Cancel": "يلغي",
    "FreeWatermarkRemover": "مزيل العلامة المائية الحرة",
    "Processing": "يعالج...",
    "NewImage": "صورة جديدة",
    "Retry": "إعادة المحاولة",
    "Yes": "نعم",
    "No": "لا",
    "FailureFeedback": "ردود الفشل",
    "removeTip": "بعد اختيار منطقة العلامة المائية ، يرجى النقر فوق إزالة لمحو العلامة المائية.",
    "rightDown": "قم بتنزيل صور منخفضة الجودة",
    "history_will": "سوف تنتهي بعد",
    "Expired": "(منتهي الصلاحية)",
    "uploadImage": "إضافة صورة",
    "uploadImageInfo": "أو إسقاط ملف الصور الخاص بك هنا لإزالة العلامة المائية!",
    "Unlimited": "غير محدود",
    "watermark_beyond_pixel_3": "تتجاوز الصورة المحددة <span> ٪ S × ٪ S </span> ، يرجى ترقية خطتك أولاً.",
    "watermark_beyond_size_3": "تتجاوز الصورة المحددة <span> ٪ smb </span> ، يرجى ترقية خطتك أولاً.",
    "no_user_login": "يمكن للمستخدمين الجدد الذين يسجلون الحصول على ثلاثة مزايا لتنزيل الصورة الأصلية HD.",
    "Upgrade": "يرقي",
    "Loading": "تحميل…",
    "SelectAll": "حدد كل شيء",
    "Open": "يفتح",
    "Delete": "يمسح",
    "Clear": "واضح غير صالح",
    "noHistory": "لا يوجد تاريخ",
    "Close": "يغلق",
    "buyUserInfo": "ongratulations! ",
    "buyNoUserInfo": "مبروك! ",
    "GetStarted": "ابدأ",
    "AccessTo": "الوصول إلى:",
    "imagesOfwatermarkremoval": "صور لإزالة العلامة المائية",
    "upTo": "حتى",
    "perImage": "لكل صورة",
    "Support": "يدعم",
    "resolution": "دقة",
    "PrepaidPackage": "حزمة مسبقة الدفع",
    "PayasYouGo": "ادفع كما تذهب",
    "TaxIncl": "ضريبة بما في ذلك.",
    "Checkout": "الدفع",
    "imagesDay": "الصور/اليوم",
    "imagesMonthly": "الصور/شهرية",
    "image": "صورة",
    "images": "الصور",
    "imageSize": "حجم الصورة",
    "buyInfo1": "طرف ثالث <span> Indistrations </span>",
    "buyInfo2": "تاريخ التحرير صالح لمدة 7 أيام",
    "buyInfo3": "معالجة الأولوية",
    "buyInfo4": "7x24 دعم العملاء",
    "buyInfo5": "انتهت صلاحية بعد 24 ساعة",
    "buyInfo6": "لا اشتراك. ",
    "buyInfo7": "متاح للاستخدام في أي وقت إلى الأبد",
    "dayPlan": "خطة يوم واحد",
    "Lifetime": "حياة",
    "note": "<span> ملاحظة </span>: يرجى ملاحظة أن الخطة المشتراة مرتبطة بعنوان البريد الإلكتروني المقدم أثناء الخروج. ",
    "buy_now": "اشتري الآن",
    "banner_title": "تنظيف صور الذكاء الاصطناعي - كم عدد الاعتمادات التي تريدها",
    "banner_info": "1 ائتمان = صورة واحدة: ستكلف 1 رصيدًا للمعالجة وحفظ صورة أكبر من 600 × 600 بكسل. ",
    "monthlyPlan_title": "خطة شهرية",
    "monthlyPlan_displayPricePerCredit": "/ائتمان",
    "monthlyPlan_plan1_credits": "اعتمادات/مو",
    "monthlyPlan_feature1": "<span> خالية من المخاطر: </span> ضمان استرداد الأموال لمدة 30 يومًا",
    "monthlyPlan_feature2": "<span> التلقائي: </span> يتم تجديد الاعتمادات تلقائيًا",
    "monthlyPlan_feature3": "<span> مرن: </span> خفض التصنيف أو الترقية أو الإلغاء في أي وقت",
    "oneTimePurchase_title": "شراء لمرة واحدة",
    "oneTimePurchase_plan5_credits": "الاعتمادات/العمر",
    "oneTimePurchase_feature1": "ضمان استرداد المال لمدة 30 يومًا",
    "oneTimePurchase_feature2": "صالح بشكل دائم بعد الشراء",
    "payment_title": "يمكنك اختيار طرق دفع متعددة",
    "payment_image_alt": "طرق الدفع",
    "faq_title": "كثيرا ما يتم طرح الأسئلة حول شراء الاعتمادات",
    "faq_question1_title": "ما هي الاعتمادات؟",
    "faq_question1_info": "يتم قياس خدمتنا في وحدة الاعتمادات. ",
    "faq_question2_title": "هل يجب أن أختار اشتراكًا شهريًا أو عملية شراء لمرة واحدة؟",
    "faq_question2_info": "بالنسبة لمهام الصور غير المنتظمة أو متطلبات الاستخدام النادرة ، يمكنك اختيار عملية شراء لمرة واحدة ، حيث يمكنك شراء الكمية المناسبة من الاعتمادات بناءً على متطلبات الصور الخاصة بك. ",
    "faq_question3_title": "ماذا لو استخدمت أرصادي؟",
    "faq_question3_info": "يمكنك ترقية اشتراكك أو متابعة شراء خطة شراء لمرة واحدة بناءً على احتياجات معالجة الصور الخاصة بك. ",
    "faq_question4_title": "هل يمكنني الترقية أو خفض أو إلغاء اشتراكي؟",
    "faq_question4_info": "نعم ، يمكنك. ",
    "whyChoose_title": "لماذا تختار Tipard",
    "whyChoose_reason1_title": "تنزيل آمن",
    "whyChoose_reason1_info": "برامج من Tipard نظيفة وآمنة 100 ٪",
    "whyChoose_reason2_title": "التكنولوجيا المهنية",
    "whyChoose_reason2_info": "يوفر الفريق الماهر منتجات مهنية",
    "whyChoose_reason3_title": "24/7 دعم العملاء",
    "whyChoose_reason3_info": "خدمات استشاري المريض طوال الوقت",
    "whyChoose_reason4_title": "30 يومًا استرداد المال",
    "whyChoose_reason4_info": "ضمان استرداد المستخدمين في 30 يومًا",
    "whyChoose_reason5_title": "1،000،000+ مستخدم",
    "whyChoose_reason5_info": "تستخدم وثقة من قبل أكثر من مليون شخص",
    "whyChoose_reason6_title": "160+ دولة",
    "whyChoose_reason6_info": "تباع في أكثر من 160 دولة ومنطقة"
}